<template>
  <div class="main_right">
    <div class="goldCoins">
      <div class="goldTop">
        <div class="imgs">
          <div class="img one">
            <img src="../../../assets/images/student/dier.png" alt="">
            <div class="head_portrait">
              <img src="../../../assets/images/student/headPortrait.png" alt="">
            </div>
            <p class="name">{{ tableData[1] ? tableData[1].xsmc : '虚席以待' }}</p>
            <p class="fraction">{{ tableData[1] ? (tableData[1].sl + '个') : '' }}</p>
          </div>
          <div class="img two">
            <img src="../../../assets/images/student/diyi.png" alt="">
            <div class="head_portrait">
              <img src="../../../assets/images/student/headPortrait.png" alt="">
            </div>
            <p class="name">{{ tableData[0] ? tableData[0].xsmc : '虚席以待' }}</p>
            <p class="fraction">{{ tableData[0] ? (tableData[0].sl + '个') : '' }}</p>
          </div>
          <div class="img three">
            <img src="../../../assets/images/student/disan.png" alt="">
            <div class="head_portrait">
              <img src="../../../assets/images/student/headPortrait.png" alt="">
            </div>
            <p class="name">{{ tableData[2] ? tableData[2].xsmc : '虚席以待' }}</p>
            <p class="fraction">{{ tableData[2] ? (tableData[2].sl + '个') : '' }}</p>
          </div>
        </div>
      </div>
      <div class="goldBottom">
        <el-table v-if="tableData.length > 3" :row-class-name="tableRowClassName" class="table" style="height:100%;" :data="tableData" border :header-cell-style="{background:'#F1F8FF',color:'#333','text-align':'center'}">
            <el-table-column type="index" label="本次排名" width="100" align="center" />
            <el-table-column prop="dcmc" align="center" label="头像">
              <!-- <template slot-scope="scope"> -->
              <template>
                <span class="head">
                  <img src="../../../assets/images/student/headPortrait.png" alt="">
                </span>
              </template>
            </el-table-column>
            <el-table-column prop="xsmc" label="姓名" align="center" />
            <el-table-column prop="sl" label="金币个数" align="center" />
        </el-table>
        <div v-else class="table" style="border:1px solid #EBEEF5;height:100%;position:relative;">
          <div class="default">
            <img src="../../../assets/images/student/defult.png" alt="">
            <span>虚席以待</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { getCoinRanking } from '@/api/student'
export default {
  data(){
    return{
      tableData:[]
    }
  },
  created() {
    if (JSON.parse(sessionStorage.getItem('jxInfo')).bjid) {
      getCoinRanking({ bjid: JSON.parse(sessionStorage.getItem('jxInfo')).bjid, yycdid: Number(sessionStorage.getItem('yycdid')) }).then(res => {
        if (res.success) {
          if (res.result.length) {
            this.tableData = res.result // .concat(res.result).concat(res.result).concat(res.result).concat(res.result)
          } else {
            this.$message.warning('暂无排行')
          }
        } else {
          this.$message.warning(res.resultDesc)
        }
      })
    } else {
      this.$message.warning('暂无所属班级')
    }
  },
  methods: {
    tableRowClassName(row) {
      return row.rowIndex < 3 ? 'hidden-row' : ''
    }
  }
}
</script>
<style lang="scss" scoped>
.main_right{
  width: calc(100% - 10.5vw);
  height: 100%;
  float: left;
  box-sizing: border-box;
  padding: 0 2%;
  position: relative;
}
.goldCoins{
  width: 100%;
  height: 100%;
  box-shadow: 0px 0px 16px 0px rgba(89, 144, 255, 0.3);
  border-radius: 10px;
  padding: 2%;
  box-sizing: border-box;
  .goldTop{
    height: 40%;
    // background: #eee;
    position: relative;
    .imgs{
      width: 40%;
      height: 95%;
      position: absolute;
      top: 10%;
      left: 50%;
      transform: translate(-50%);
      // position: relative;
      .img{
        float: left;
        width: 33%;
        height: 100%;
        position: absolute;
        bottom: 0;
        img{
          display: block;
          width: 100%;
          height: 100%;
        }
      }
      .img:nth-child(1){
        left: 0;
        .head_portrait{
          width: 2.6vw;
          height: 2.6vw;
          border: 1px solid #5990FF;
          border-radius: 50%;
          position: absolute;
          top: 40%;
          left: 50%;
          transform: translateX(-50%);
          img{
            display: block;
            width: 100%;
            height: 100%;
            border-radius: 50%;
          }
        }
        .name{
          position: absolute;
          top: 65%;
          left: 50%;
          transform: translateX(-50%);
          font-size: 1vw;
        }
        .fraction{
          position: absolute;
          top: 78%;
          left: 50%;
          transform: translateX(-50%);
          font-size: 1vw;
        }
      }
      .img:nth-child(2){
        width: 34%;
        height: 115%;
        left: 33%;
        .head_portrait{
          width: 3vw;
          height: 3vw;
          border: 1px solid #F5CF04;
          border-radius: 50%;
          position: absolute;
          top: 40%;
          left: 50%;
          transform: translateX(-50%);
          img{
            display: block;
            width: 100%;
            height: 100%;
            border-radius: 50%;
          }
        }
        .name{
          position: absolute;
          top: 65%;
          left: 50%;
          transform: translateX(-50%);
          font-size: 1vw;
        }
        .fraction{
          position: absolute;
          top: 78%;
          left: 50%;
          transform: translateX(-50%);
          font-size: 1vw;
        }
        img{
          display: block;
          width: 100%;
          height: 100%;
        }
      }
      .img:nth-child(3){
        left: 67%;
        height: 90%;
        .head_portrait{
          width: 2.4vw;
          height: 2.4vw;
          border: 1px solid #FE721D;
          border-radius: 50%;
          position: absolute;
          top: 40%;
          left: 50%;
          transform: translateX(-50%);
          img{
            display: block;
            width: 100%;
            height: 100%;
            border-radius: 50%;
          }
        }
        .name{
          position: absolute;
          top: 65%;
          left: 50%;
          transform: translateX(-50%);
          font-size: 1vw;
        }
        .fraction{
          position: absolute;
          top: 78%;
          left: 50%;
          transform: translateX(-50%);
          font-size: 1vw;
        }
      }
    }
  }
  .goldBottom{
    height: 60%;
  }
}
.head{
  display: block;
  width: 2.5vw;
  height: 2.5vw;
  border-radius: 50%;
  border: 1px solid #5990FF;
  margin: auto;
  img{
    display: block;
    width: 100%;
    height: 100%;
    border-radius: 50%;
  }
}
.default{
  width: 18.33vw;
  height: 13vw;
  position: absolute;
  top: 41%;
  left: 50%;
  transform: translate(-50%, -50%);
  img{
    width: 100%;
    height: 100%;
    display: block;
  }
  span{
    display: block;
    font-size: 1.3vw;
    color: #333;
    position: absolute;
    bottom: -3vw;
    left: 50%;
    transform: translateX(-50%);
  }
}
/* ========== 手机端适配样式 ========== */
@media screen and (max-width: 768px) {
  .main_right {
    width: calc(100% - 80px);
    padding: 0 10px;
    height: 100%;
    overflow: auto;

    .goldCoins {
      padding: 15px 10px;
      height: auto;
      min-height: 100%;

      .goldTop {
        height: auto;
        margin-bottom: 20px;

        .imgs {
          width: 90%;
          height: auto;
          position: relative;
          top: auto;
          left: auto;
          transform: none;
          display: flex;
          justify-content: center;
          align-items: flex-end;
          margin: 0 auto;

          .img {
            position: relative;
            width: 30%;
            height: auto;
            float: none;
            left: auto !important;
            top: auto !important;

            img {
              width: 100%;
              height: auto;
            }

            .head_portrait {
              width: 40px !important;
              height: 40px !important;
              top: 28% !important;
              left: 50% !important;
              transform: translateX(-50%) !important;

              img {
                width: 100%;
                height: 100%;
              }
            }

            .name {
              font-size: 12px !important;
              top: 58% !important;
              white-space: nowrap;
            }

            .fraction {
              font-size: 11px !important;
              top: 70% !important;
            }
          }

          .img:nth-child(2) {
            height: auto;
            margin-top: -10px;

            .head_portrait {
              width: 48px !important;
              height: 48px !important;
            }
          }

          .img:nth-child(1) .head_portrait,
          .img:nth-child(3) .head_portrait {
            width: 36px !important;
            height: 36px !important;
          }
        }
      }

      .goldBottom {
        height: auto;
        min-height: 300px;

        .table {
          height: auto !important;
          min-height: 300px;

          ::v-deep  .el-table__body-wrapper {
            overflow-x: auto !important;
          }

          ::v-deep  .el-table__header {
            min-width: 400px;
          }

          ::v-deep  .el-table__body {
            min-width: 400px;
          }

          ::v-deep  .el-table__fixed {
            display: none !important;
          }

          ::v-deep  .el-table__fixed-right {
            display: none !important;
          }
        }

        .default {
          width: 150px;
          height: 110px;
          position: relative;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);

          img {
            width: 100%;
            height: 100%;
          }

          span {
            font-size: 14px;
            bottom: -30px;
            white-space: nowrap;
          }
        }
      }
    }
  }

  .head {
    width: 32px !important;
    height: 32px !important;

    img {
      width: 100%;
      height: 100%;
    }
  }
}

@media screen and (max-width: 480px) {
  .main_right {
    width: calc(100% - 65px);
    padding: 0 8px;

    .goldCoins {
      padding: 12px 8px;

      .goldTop .imgs {
        width: 100%;

        .img {
          .head_portrait {
            width: 32px !important;
            height: 32px !important;
          }

          .name {
            font-size: 10px !important;
          }

          .fraction {
            font-size: 9px !important;
          }
        }

        .img:nth-child(2) .head_portrait {
          width: 38px !important;
          height: 38px !important;
        }

        .img:nth-child(1) .head_portrait,
        .img:nth-child(3) .head_portrait {
          width: 28px !important;
          height: 28px !important;
        }
      }

      .goldBottom {
        .default {
          width: 120px;
          height: 88px;

          span {
            font-size: 12px;
            bottom: -25px;
          }
        }
      }
    }
  }

  .head {
    width: 28px !important;
    height: 28px !important;
  }
}
</style>
<style lang="scss">
.main_right{
  .el-table{
    .hidden-row{
      display: none;
    }
  }
}
</style>
